import {ToastBuilder} from "@intuitionrobotics/thunderstorm/frontend";

export const APP_TOAST_BUILDER = new ToastBuilder().setDuration(10000).setHorizontalPosition("right").setVerticalPosition("bottom");